var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"box"},[_c('p',{},[_vm._v("长按转发海报")]),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.url,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }